module.exports = __webpack_public_path__ + "media/fonts/SFProText-Light-a8b3001a1714375985847832d8878aac.svg";